export const LIVELIHOOD_INCIDENT_BUSINESS_SERVICE = "LivelihoodIncident";

export const APPLICATION_STATUS = {
  PENDING_FOR_RESOLUTION: "PENDING_FOR_RESOLUTION",
  OUT_OF_SCOPE_PENDING_POC: "OUT_OF_SCOPE_PENDING_POC",
  OUT_OF_SCOPE_PENDING_VENDOR: "OUT_OF_SCOPE_PENDING_VENDOR",
  OUT_OF_WARRANTY_PENDING_VENDOR: "OUT_OF_WARRANTY_PENDING_VENDOR",
  RESOLVED: "RESOLVED",
  CLOSED_AFTER_RESOLUTION: "CLOSED_AFTER_RESOLUTION",
  CLOSED_AFTER_DECLINE: "CLOSED_AFTER_DECLINE",
} as const;

/** Sentinel stored in InboxRow.sla for an overdue ticket; translated at render time. */
export const SLA_OVERDUE_MARKER = "OVERDUE";

/**
 * Sentinel stored in InboxRow.taskOwner for a ticket waiting on the Program POC; translated at
 * render time. The backend leaves these tickets unassigned so that every POC can pick them up.
 */
export const PROGRAM_POC_OWNER_MARKER = "PROGRAM_POC";

/** Statuses owned by the pooled Program POC role rather than by a named user. */
export const POC_OWNED_STATUSES = [APPLICATION_STATUS.OUT_OF_SCOPE_PENDING_POC] as const;

/** English shown when a status has no localisation message; otherwise the raw code is shown. */
const STATUS_FALLBACK_LABELS: Record<string, string> = {
  [APPLICATION_STATUS.OUT_OF_SCOPE_PENDING_POC]: "Pending with Program POC",
};

export function statusFallbackLabel(status: string): string {
  return STATUS_FALLBACK_LABELS[status] ?? status;
}

export const BLANK_SLA_STATUSES = [
  APPLICATION_STATUS.RESOLVED,
  APPLICATION_STATUS.CLOSED_AFTER_RESOLUTION,
  APPLICATION_STATUS.CLOSED_AFTER_DECLINE,
] as const;

export const RESOLVED_APPLICATION_STATUSES = [
  APPLICATION_STATUS.RESOLVED,
  APPLICATION_STATUS.CLOSED_AFTER_RESOLUTION,
] as const;

export const TERMINAL_APPLICATION_STATUSES = [
  APPLICATION_STATUS.CLOSED_AFTER_RESOLUTION,
  APPLICATION_STATUS.CLOSED_AFTER_DECLINE,
] as const;

export const OPEN_DUPLICATE_APPLICATION_STATUSES = [
  APPLICATION_STATUS.PENDING_FOR_RESOLUTION,
  APPLICATION_STATUS.OUT_OF_SCOPE_PENDING_POC,
  APPLICATION_STATUS.OUT_OF_SCOPE_PENDING_VENDOR,
  APPLICATION_STATUS.OUT_OF_WARRANTY_PENDING_VENDOR,
  APPLICATION_STATUS.RESOLVED,
].join(",");

/** Unassigned tickets visible to these roles for SLA display. */
export const ROLE_STATUS_MAPPING: Record<string, string[]> = {
  [APPLICATION_STATUS.PENDING_FOR_RESOLUTION]: ["LIVELIHOOD_VENDOR", "COMPLAINT_RESOLVER"],
  [APPLICATION_STATUS.OUT_OF_SCOPE_PENDING_POC]: ["LIVELIHOOD_POC"],
  [APPLICATION_STATUS.OUT_OF_SCOPE_PENDING_VENDOR]: ["LIVELIHOOD_VENDOR", "COMPLAINT_RESOLVER"],
  [APPLICATION_STATUS.OUT_OF_WARRANTY_PENDING_VENDOR]: ["LIVELIHOOD_VENDOR", "COMPLAINT_RESOLVER"],
};
